const getGlobalState = (state, key) => (Array.isArray(state.featuresFlag[key]) ? state.featuresFlag[key].slice(0) : state.featuresFlag[key]);

export const getFeaturesFlag = (state) => getGlobalState(state, 'featuresFlagList') || [];

export default {};